import React, { useEffect } from 'react';

export function TermsAndConditions () {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://app.termly.io/embed-policy.min.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <>
      <div
        name="termly-embed"
        data-id="a51a39c5-131b-4a1d-bc67-d44b95760ee5"
        data-type="iframe"
      />
    </>
  );
}
